import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";

import ApiService from "services/ApiService";
import AuthService from "services/AuthService";
import { ContextOne } from "contexts/ContextOne";
import { dateLocalDisplay } from "lib/Utils";
import Spinner from "components/UI/Spinner";
import Modal from "components/UI/Modal";
import { ToasterContext } from "contexts/ToasterContext";
import withAuth from "withAuth";
import UserSelectForm from "components/Users/UserSelectForm";
//import AiModelSelectForm from "components/Organization/AiModelSelectForm";

import "./Organization.scss";

const Organization = () => {
  const { uuid } = useParams();

  const { state: { loading }, dispatch } = useContext(ContextOne);
  const { AddToast } = useContext(ToasterContext);

  const [organization, setOrganization] = useState(null);
  const [users, setOrganizationUsers] = useState(null);
  const [aiModels, setOrganizationAiModels] = useState(null);
  const [projects, setOrganizationProjects] = useState(null);

  const [showUserSelectForm, setShowUserForm] = useState(false);

  // Routing

  let navigate = useNavigate();

  const routeToAiModel = (uuid) => {
    let path = `/ai-models/${uuid}`;
    navigate(path);
  };

  const routeToProject = (uuid) => {
    let path = `/projects/${uuid}`;
    navigate(path);
  };

  // Data Fetching

  const fetchData = async () => {
    dispatch({ type: "loading", val: true });
    {
      const organization = await ApiService.getOrganization(uuid);
      setOrganization(organization);

      const users = await ApiService.getOrganizationUsers(uuid);
      setOrganizationUsers(users);

      const aiModels = await ApiService.getOrganizationAiModels(uuid);
      setOrganizationAiModels(aiModels);

      const projects = await ApiService.getOrganizationProjects(uuid);
      setOrganizationProjects(projects);
    }
    dispatch({ type: "loading", val: false });
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // User Modal

  const handleUserSubmit = async (user) => {
    dispatch({ type: "loading", val: true });

    AuthService.fetch(
      `${process.env.REACT_APP_API_ENDPOINT}/organizations/${uuid}/add_user`,
      {
        method: "POST",
        body: JSON.stringify({
          email: user.email,
        }),
      }
    )
      .then(
        async () => {
          await fetchData();
          AddToast("success", "User added", null);
          return;
        },
        (error) => {
          AddToast("danger", null, error);
          return;
        }
      )
      .then(() => {
        dispatch({ type: "loading", val: false });
        setShowUserForm(false);
      });
  };

  const handleUserShowModal = (event) => {
    event.preventDefault();

    setShowUserForm(true);
  };

  const handleUserCloseModal = (_event) => {
    setShowUserForm(false);
  };

  return (
    <>
      <div className="organization-component">
        <Spinner show={loading} />

        <div className="text-center">
          <div className="organization-header">
            <div className="organization-name">{organization?.name}</div>
            <div className="organization-created">
              created at: {dateLocalDisplay(organization?.created_at)},{" "}
              {organization?.status}
            </div>
          </div>
          <div className="organization-subheader">Users</div>
          <table className="table tbl-striped table-sm">
            <thead>
              <tr>
                <th>Username</th>
                <th>Email</th>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Status</th>
                <th>Admin?</th>
                <th>
                  <div className="icon-button" onClick={handleUserShowModal}>
                    <FontAwesomeIcon icon={faPlusCircle} />
                  </div>
                </th>
              </tr>
            </thead>

            <tbody>
              {users?.map((u) => (
                <tr key={u.uuid}>
                  <td>{u.username}</td>
                  <td>{u.email}</td>
                  <td>{u.first_name}</td>
                  <td>{u.last_name}</td>
                  <td>{u.status}</td>
                  <td>{u.is_admin || false}</td>
                  <td></td>
                </tr>
              ))}
            </tbody>
          </table>
          <br />
          <div className="organization-subheader">AI Models</div>
          <table className="table tbl-striped table-sm">
            <thead>
              <tr>
                <th>Name</th>
                <th>Artist</th>
                <th>Description</th>
                <th>Model Name</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {aiModels?.map((a) => (
                <tr key={a.uuid} onClick={() => routeToAiModel(a.uuid)}>
                  <td>{a.name}</td>
                  <td>{a.artist}</td>
                  <td>{a.description}</td>
                  <td>{a.model_name}</td>
                  <td></td>
                </tr>
              ))}
            </tbody>
          </table>
          <br />
          <div className="organization-subheader">Projects</div>
          <table className="table tbl-striped table-sm">
            <thead>
              <tr>
                <th>Name</th>
                <th>Description</th>
                <th>Created By</th>
                <th>Created Date</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {projects?.map((p) => (
                <tr key={p.uuid} onClick={() => routeToProject(p.uuid)}>
                  <td>{p.name}</td>
                  <td>{p.description}</td>
                  <td>{dateLocalDisplay(p.created_at)}</td>
                  <td>{dateLocalDisplay(p.updated_at)}</td>
                  <td>{p.status}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Modals */}

      <Modal show={showUserSelectForm} modalClosed={handleUserCloseModal}>
        <h4 className="text-center">Add User</h4>
        <hr />

        {showUserSelectForm && (
          <UserSelectForm
            cancelForm={handleUserCloseModal}
            handleSubmit={handleUserSubmit}
          />
        )}
      </Modal>
    </>
  );
};

export default withAuth(Organization);
